import React from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { useAuth } from "./UseAuth";

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

export default function PrivateRoute({
  component: Component,
  ...rest
}: PrivateRouteProps) {
  const { currentUser, loading } = useAuth();
  return (
    <Route
      {...rest}
      render={(props) => {
        if (loading) {
          return (
            <div className="flex justify-center items-center h-screen">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
            </div>
          );
        }

        return currentUser?.uid ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        );
      }}
    />
  );
}
